import { useRef, useEffect } from 'react'
import Button from '../Button.jsx'
import Field from '../form/Field.jsx'
import Hidden from '../form/Hidden.jsx'
import { PlatformPolicyRestrictionsList, PlatformPolicyOptionsList } from '../../repo/PlatformPoliciesRepo.js'

export default function AdminPlatformPoliciesForm({platformPolicy, tournament, errors, isSubmitting}) {
  const idRef = useRef()
  const platformNameRef = useRef()
  const restrictionRef = useRef()
  const descriptionRef = useRef()
  const tournamentIdRef = useRef()

  useEffect(() => {
    tournamentIdRef.current.value = tournament.id

    if (platformPolicy) {
      idRef.current.value = platformPolicy.id;
      platformNameRef.current.value = platformPolicy.platform_name;
      restrictionRef.current.value = platformPolicy.restriction;
      descriptionRef.current.value = platformPolicy.description;
    } else {
      platformNameRef.current.value = '';
      restrictionRef.current.value = '';
      descriptionRef.current.value = '';
    }
  }, [platformPolicy, tournament]);


  function platformNameHasError() {
    if (errors && errors.platform_name) {
      return "Plataforma inválida"
    }

    return ""
  }

  function restrictionHasError() {
    if (errors && errors.restriction) {
      return "Restrição inválida"
    }

    return ""
  }

  return(
    <>
      <Field
        type={"select"}
        name={"platform_name"}
        id={"platform_name"}
        label={"Plataforma"}
        required={""}
        options={PlatformPolicyOptionsList()}
        defaultValue={''}
        error={platformNameHasError()}
        disabled={isSubmitting}
        ref={platformNameRef}/>

      <Field
        type={"select"}
        name={"restriction"}
        id={"restriction"}
        label={"Restrição"}
        required={""}
        options={PlatformPolicyRestrictionsList()}
        defaultValue={''}
        error={restrictionHasError()}
        disabled={isSubmitting}
        ref={restrictionRef}/>

      <Field
        type={"input"}
        name={"description"}
        id={"description"}
        label={"Descrição"}
        required={""}
        disabled={isSubmitting}
        ref={descriptionRef}/>

      <Hidden ref={tournamentIdRef} name={"tournament_id"} id={"tournament_id"} />

      {platformPolicy && platformPolicy.id && (
        <Hidden ref={idRef} name={"id"} id={"id"} />
      )}

      <Button styleName="blue" disabled={isSubmitting} >
        {isSubmitting ? 'Saving...' : 'Save'}
      </Button>
    </>
  )
}
